





































































































































import { computed, defineComponent, watch } from '@vue/composition-api';

import CommonUnitSelector from '@/components/Delivery/CommonUnitSelector.vue';

const ItemOrder = defineComponent({
  components: { CommonUnitSelector },
  props: {
    index: {
      type: Number,
      default: 0,
    },
    length: {
      type: Number,
      default: 0,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    const toDecimalFormat = (string: string, digit = 2) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: digit, maximumFractionDigits: digit });
    const computedCountPerPackageUnits = computed(() => {
      // eslint-disable-next-line
      if (props.value.total === '' || props.value.total == 0 || props.value.count === '' || props.value.count == 0) return '';

      return (props.value.count / props.value.total || 1).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 6 });
    });
    const computedDeliveryFee = computed(() => props.value.deliveryFee);
    watch(() => computedCountPerPackageUnits.value, (newVal, oldVal) => {
      if (newVal !== oldVal) {
        emit('input', { ...props.value, unitsPerCount: newVal });
      }
    });

    function deliveryFeeRateInput($event: any) {
      emit('input', { ...props.value, deliveryFee: $event * (props.value.total || 0) });
    }
    function itemCountInput($event: any) {
      emit('input', { ...props.value, deliveryFee: (props.value.deliveryFeeRate || 0) * $event });
    }

    return {
      computedCountPerPackageUnits,
      computedDeliveryFee,
      toDecimalFormat,
      deliveryFeeRateInput,
      itemCountInput,
    };
  },
});

export default ItemOrder;
